import React, { memo, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import classNames from 'classnames';
import PosterCard from '../../components/PosterCard/PosterCard';
import styles from './HotSall.module.less';
import { logging } from '../../actions/log';
import { useInView } from 'react-intersection-observer';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(({ data = {}, logInfo }) => {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const [showCards, setShowCards] = useState([]);
  const [cards, setCards] = useState([]);
  const [mark, setMark] = useState(0); // 支持换一换功能时记录的数组的下标
  const [len, setLen] = useState(0); // 页面导流卡片实际展示个数

  const LOG_ACTION_SOURCE = {
    c_click: `${logInfo.tag}_HotSell`,
    c_hover: `${logInfo.tag}_HotSell_hover`,
    c_change: `${logInfo.tag}_HotSell_Change`,
    source: `${logInfo.tag}_HotSell`,
  };

  const [ref, inView] = useInView({
    threshold: 1,
  });

  useEffect(() => {
    if (inView && logInfo && logInfo.changView) {
      logInfo.changView({
        pageCardId: data && data.dataList && data.dataList[0] && data.dataList[0].pageCardContentId,
        pageCardTitle: data && data.title,
        rankCode: data && data.dataList && data.dataList[0] && data.dataList[0].code,
        cardType: data && data.cardType,
      });
    }
  }, [inView]);

  useEffect(() => {
    const { dataList = [] } = data;
    if (!dataList[0]) {
      return;
    }

    const info = dataList[0] || {};
    let advertList = info.advertList || [];
    advertList = advertList.filter(item => {
      return item.imgUrl;
    });
    setCards(advertList);

    if (advertList.length < data.row * 3) {
      setShowCards(() => {
        return advertList.slice(0, 3);
      });
      setLen(3);
      setMark(3);
      return;
    }

    setLen(() => {
      return data.row * 3;
    });
    setShowCards(() => {
      return advertList.slice(0, data.row * 3);
    });
    setMark(data.row * 3);
  }, [data && data.dataList[0] && data.dataList[0] && data.dataList[0].advertList]);

  const handleChange = () => {
    const cardList = [];
    for (let index = mark; index < mark + len; index += 1) {
      cardList.push(cards[index % cards.length]);
    }
    setMark((mark + len) % cards.length);
    setShowCards(cardList);

    // 换一换打桩
    dispatch(
      logging({
        category: 'C',
        action: LOG_ACTION_SOURCE.c_change,
        label: '',
        param2: {
          source: LOG_ACTION_SOURCE.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
  };

  if (showCards.length < 1) {
    return null;
  }

  return (
    <div className={styles.card} ref={ref}>
      <div className={styles.card_header}>
        <div className={styles.card_header_title}>
          {data.dataList && data.dataList[0] && data.dataList[0].name}
        </div>
        {cards.length > len && (
          <div className={styles.card_header_icon} onClick={handleChange}>
            <i className={classNames(styles.refresh_icon, 'iconfont icon-refresh1')} />
            <span>换一换</span>
          </div>
        )}
      </div>
      <div className={styles.content_column3}>
        {showCards.map(item => (
          <PosterCard
            data={item}
            key={item.id}
            logInfo={{
              ...logInfo,
              code: data.dataList && data.dataList[0] && data.dataList[0].code,
            }}
          />
        ))}
      </div>
    </div>
  );
});
